import { Brandfolder as BF, Organization as Org } from '@brandfolder/types';

export interface Brandfolder extends BF {
  key: string;
}

export interface Organization extends Org {
  key: string;
}

export enum PeoplePageParamKeys {
  Filter = 'filter',
  Search = 'search',
  Sort = 'sort',
  Page = 'page',
}

export enum PersonDetailsParamKeys {
  Tag = 'tag',
  Sort = 'sort',
  Page = 'page',
}

export enum FilterValues {
  All = 'all',
  Tagged = 'tagged',
  Untagged = 'untagged',
}

export enum SortValues {
  UploadDateNewest = 'upload-date-newest',
  UploadDateOldest = 'upload-date-oldest',
  FrequencyLeast = 'frequency-least',
  FrequencyMost = 'frequency-most',
  NameAscending = 'name-ascending',
  NameDescending = 'name-descending',
}

export type PeoplePageQueryState = {
  [key in PeoplePageParamKeys]?: FilterValues | SortValues | string;
};

export type PersonDetailsQueryState = {
  [key in PersonDetailsParamKeys]?: SortValues | string;
};

export type PeoplePageQueryDispatch = (nextState: PeoplePageQueryState) => void;

export type PersonDetailsQueryDispatch = (nextState: PersonDetailsQueryState) => void;
